import { FileZip } from '@phosphor-icons/react';

export default FileZip;
